import ValueTracker from "../prop-trackers/value-tracker.js";
import { ValueCombiner as ValueMerger } from "../prop-tracker-utils/combiner.js";

class ShallowObjectMerger extends ValueMerger {
    constructor() {
        super();

        this._values = {};
        this._tracker = new ValueTracker();

        this._tracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    setValue(id, value) {
        this._values[id] = value;
        this._updateValue();
    }

    deleteValue(id) {
        delete this._values[id];
        this._updateValue();
    }

    _updateValue() {
        for (const id in this._values) {
            this._tracker.setValue(this._values[id]);
            return;
        }

        this._tracker.deleteValue();
    }

    protected_startUpdate() {
        return this._tracker.startUpdate();
    }

    protected_finishUpdate() {
        this._tracker.finishUpdate();
    }
}

export default ShallowObjectMerger;
